export const crudListStyle = theme => ({
  newButton: {
    margin: '0 0 0 15px',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  newButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  },
  crudHeader: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '4rem',
    justifyContent: 'flex-end'
  },
  crudTitle: {
    flex: 1
  },
  searchBar: {
    margin: '0',
    padding: '16px 0',
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap'
  },
  searchBarWrapper: {
    height: '40px',
    '& > button': {
      height: '40px',
      width: '40px'
    },
    '& > button:last-child': {
      marginRight: '0'
    },
    '& > button:first-child': {
      marginRight: '-40px'
    },
    '& > div': {
      width: 'calc(100% - 75px)'
    }
  },
  '@media only screen and (max-width: 768px)': {
    searchBarWrapper: {
      flex: 1,
      width: '40%'
    },
    crudTitle: {
      width: '100%',
      flex: 'auto',
      paddingBottom: '16px'
    }
  }
})

export default crudListStyle



// WEBPACK FOOTER //
// ./src/styles/crudList.js